var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeryGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6954 33C26.628 33 33.8693 26.0604 33.8693 17.5C33.8693 8.93959 26.628 2 17.6954 2C8.76279 2 1.52148 8.93959 1.52148 17.5C1.52148 26.0604 8.76279 33 17.6954 33Z",
    stroke: "#81BC45",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0117 13.625C10.0117 13.1111 10.2247 12.6183 10.6039 12.255C10.983 11.8916 11.4973 11.6875 12.0335 11.6875C12.5697 11.6875 13.0839 11.8916 13.463 12.255C13.8422 12.6183 14.0552 13.1111 14.0552 13.625",
    stroke: "#81BC45",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1426 13.625C22.1426 13.3706 22.1949 13.1186 22.2965 12.8836C22.3981 12.6485 22.547 12.4349 22.7347 12.255C22.9225 12.0751 23.1453 11.9324 23.3906 11.835C23.6359 11.7376 23.8988 11.6875 24.1643 11.6875C24.4298 11.6875 24.6927 11.7376 24.938 11.835C25.1833 11.9324 25.4062 12.0751 25.5939 12.255C25.7816 12.4349 25.9306 12.6485 26.0322 12.8836C26.1338 13.1186 26.1861 13.3706 26.1861 13.625",
    stroke: "#81BC45",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3496 21.65C11.3496 21.65 13 23.5 17.5 23.5C22 23.5 23.6496 21.65 23.6496 21.65",
    stroke: "#81BC45",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryGood);
export default __webpack_public_path__ + "static/media/very_good.3ddb8e40b9be67b02213770d3b4a6f65.svg";
export { ForwardRef as ReactComponent };